import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SitesEnum } from '~/shared/enums/sites.enum';
import { SecurityService } from '~/services/security.service';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { ISiteListing } from '~/models/modules/Common/siteDto';
import { ComponentBase } from './component-base';

@Component({
    selector: 'app-multi-site-aware', template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class MultiSiteAwareComponent extends ComponentBase {
  private _multiSiteSecurityService = inject(SecurityService);

  _selectedAccountIds: any[] = [];
  _selectedAccounts: any[] = [];
  _tabEnabled: boolean = false;
  siteId: number;
  _isMultiSite: boolean = false;
  _isMultiSiteSelected: boolean = false;
  SitesEnum = SitesEnum;
  sitesData: ISiteListing[];
  isLoggedInAllSites: boolean = false;
  _siteSelected: any;
  _sites: any[] = [];
  _sitesFiltered: any[] = [];

  private _logoutUser(): void {
    this._multiSiteSecurityService.logout().subscribe();
    this._multiSiteSecurityService.removeLocalCredentials();
  }

  _onAccountRowSelectionChanges(e: any[], onSelected?: () => void): void {
    this._selectedAccounts = [];

    const hasAccountId = e.length > 0 && (e[0] as any)?.accountId != null;

    if (hasAccountId) {
      const unique = e.filter((item: any, i, arr) => arr.findIndex((t: any) => t.accountId === item.accountId) === i);
      for (const item of unique) {
        this._selectedAccounts.push({
          siteId: item.siteId != null ? item.siteId : null,
          accountId: +item.accountId,
        });
      }
      this._selectedAccountIds = this._selectedAccounts.map((c: any) => c.accountId);
    } else {
      e = e.filter((item: any, i, arr) => arr.findIndex((t: any) => t === item) === i);
      this._selectedAccounts = e;
      this._selectedAccountIds = e;
    }

    this._tabEnabled = this._selectedAccounts.length > 0;
    if (this._selectedAccounts.length) {
      onSelected?.();
    }
  }

  _loadSites(sitesService: MultiSiteService, onLoaded?: (sites: ISiteListing[]) => void): void {
    sitesService.getAllSites().subscribe((data: ISiteListing[]) => {
      this.sitesData = data.filter((s) => s.id !== SitesEnum.AllSites);
      onLoaded?.(this.sitesData);
    });
  }

  _getAccountIds(enterpriseSites?: any[]): void {
    if ((this as any)._currentUser?.isEnterprise && enterpriseSites) {
      enterpriseSites.forEach((item) => {
        this._selectedAccountIds.push(item.account?.id);
      });
    } else {
      const accountSiteData = localStorage.getItem('loggedInAccountSites');
      if (accountSiteData) {
        const JsonData = JSON.parse(accountSiteData);
        for (const s of JsonData) {
          if (s.siteId === 0 || s.siteId == null) {
            this._logoutUser();
            return;
          }
          this._selectedAccountIds.push(s.accountId);
          if (s.siteId !== SitesEnum.AllSites) {
            this.siteId = s.siteId;
          }
        }
      }
    }
  }

  _checkMultiSitesLicense(securityService: SecurityService, onAllSites?: () => void): void {
    securityService.getLicense().subscribe((data: any) => {
      if (data.general.numberOfSites > 1) {
        this._isMultiSite = true;
      }

      if (this._isMultiSite) {
        const userSites = JSON.parse(
          localStorage.getItem('loggedInAccountSites')
        );
        if (userSites && userSites.length > 0) {
          const selectedSite = userSites[0].siteId;

          if (selectedSite === 0 || selectedSite == null) {
            this._logoutUser();
            return;
          }

          if (selectedSite === SitesEnum.AllSites) {
            this._isMultiSiteSelected = true;
            onAllSites?.();
          }
        }
      }
    });
  }

  initAllSitesDropDown(isEdit: boolean = false, SavedSite: any = null): void {
    const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';
    if (loggedInAccountSites !== '') {
      const site = JSON.parse(loggedInAccountSites)[0];
      if (!site.siteId || site.siteId === SitesEnum.AllSites) {
        this.isLoggedInAllSites = true;
        if (!isEdit)
          this._siteSelected = this._sites.find(x => x.id == SitesEnum.AllSites);
      } else {
        this.isLoggedInAllSites = false;
        if (!isEdit)
          this._siteSelected = this._sites.find(x => x.id == site.siteId);
      }
      if (isEdit) {
        this._siteSelected = this._sites.find(x => x.id == SavedSite.id);
      }
    }
  }

  _handleSitesFilter(value: any): void {
    this._sitesFiltered = this._sites.filter((s: any) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  _handleSitesChange(event: any): void {
    this._siteSelected = event;
  }
}

